import toastMessage from "../../utils/toastMessage";
import language from "../../language";
import formatDropdownData from "../../utils/formatDropdownData";
import axios from "axios";
import { getStorage } from "../../utils/storage";
import api from "../../utils/api";

export const fetchCollections = async (lng = "english", params) => {
  const { listType, active } = params || {};
  const { accessToken } = await getStorage();
  let headers = {
    "Content-Type": "application/json;charset=UTF-8",
  };

  try {
    if (accessToken) {
      headers.Authorization = "Bearer " + accessToken;
    }

    const options = {
      method: "GET",
      url: `${api("core")}/collection/tills`,
      data: null, //force axios send headers content type
      params: {
        active,
      },
      headers,
    };

    const data = await axios(options);

    //filters which will be removed once they are available from the backend
    let filteredData = data.data.filter((el) => active && el.active);

    if (listType === "dropdown") {
      return formatDropdownData(
        active ? filteredData : data.data,
        "name",
        "id"
      );
    }

    return active ? filteredData : data.data;
  } catch (error) {
    toastMessage("error", language[lng].unable_to_fetch_collections);
  }
};

export const fetchCollectionCategories = async (lng = "english", params) => {
  const { listType } = params || {};
  const { accessToken } = await getStorage();
  let headers = {
    "Content-Type": "application/json;charset=UTF-8",
  };

  try {
    if (accessToken) {
      headers.Authorization = "Bearer " + accessToken;
    }

    const options = {
      method: "GET",
      url: `${api("core")}/collection/till/categories/active`,
      data: null, //force axios send headers content type
      headers,
    };

    const data = await axios(options);

    if (listType === "dropdown") {
      return formatDropdownData(data.data, "name", "id");
    }

    return data.data;
  } catch (error) {
    toastMessage("error", language[lng].unable_to_fetch_collection_categories);
  }
};
